<template>
    <div class="category-filter">
        <form
                class="category-filter--form"
                ref="form"
                :action="formUrl"
                :method="formMethod">
            <form-field-select
                    id="category"
                    :items="categories"
                    :placeholder="placeholder"
                    :facets="['base', 'select']"
                    :value="selectedCategory"
                    @change="onChange"
            />
        </form>
    </div>
</template>

<script>
    import FormFieldSelect from 'framework/global-components/dyn/form/form-field-select/form-field-select';
    import { find } from 'lodash';

    export default {
        components: { FormFieldSelect },
        props: {
            formUrl: {
                type: String,
                required: true,
            },

            formMethod: {
                type: String,
                required: true,
            },

            placeholder: {
                type: String,
                required: true,
            },

            /** @type {ICategory[]} */
            categories: {
                type: Array,
                required: true,
            },
        },

        data() {
            return {
                selectedCategory: '',
            };
        },

        methods: {
            onChange() {
                this.$refs.form.submit();
            },
        },

        mounted() {
            const activeCategory = find(this.categories, { active: true });
            if (!activeCategory) {
                this.selectedCategory = '';
                return;
            }

            this.selectedCategory = activeCategory.val;
        },
    };
</script>
